/**
 * Read query parameters from the current page URL.
 * @returns {Object} Query parameter key-value pairs
 */
export function getQueryParams() {
  const params = new URLSearchParams(window.location.search);
  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
}

/**
 * Check if Sean-only mode is active.
 * @returns {boolean} True if ?mode=sean is present
 */
export function isSeanMode() {
  const params = getQueryParams();
  return params['mode'] === 'sean';
}
